// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__iNfke","postfix":"styles_postfix__N6nFC","prefix":"styles_prefix__PX4rl"};